<script>
  import { createEventDispatcher } from "svelte"
  export let size
  export let dropdownItems
  export let activeFontFamily = "Arial"
  export let activeFontSize = 1
  export let type

  const dispatch = createEventDispatcher()
  let showDropdown = false
  let activeItem
  let dropdown
  export let codeView

  const onCloseDropDown = (e) => {
    if (dropdown.contains(e.target) == false) showDropdown = false
  }
</script>

<svelte:window on:click={onCloseDropDown} />
<div style="width:{size}px" class="relative" bind:this={dropdown}>
  <button
    on:click={() => {
      showDropdown = !showDropdown
    }}
    disabled={codeView}
    type="button"
    class="relative h-9 w-full truncate rounded-md bg-gray-50 px-3 text-left text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:cursor-not-allowed dark:bg-[#2d2d2d] dark:text-gray-200 sm:text-sm"
  >
    <div class="w-4/5 truncate text-sm">{type == "family" ? activeFontFamily.replaceAll('"', "") : activeFontSize}</div>
    <div class="absolute inset-y-0 right-0 flex aspect-square items-center justify-center dark:bg-[#2d2d2d] text-gray-900 dark:text-gray-200">
      <i class="fa-solid fa-chevron-down" />
    </div>
  </button>
  <ul style="width:{size * 2}px" class:hidden={!showDropdown} class="absolute z-10 mt-1 max-h-56 flex-col overflow-auto rounded-md border border-[#a0a1a580] bg-white pl-0 text-base ring-opacity-5 focus:outline-none dark:bg-black sm:text-sm" tabindex="-1">
    {#each dropdownItems as item}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li
        on:click={(e) => {
          activeItem = item
          let selection = document.getSelection()
          if (type == "family") {
            dispatch("familyChosen", selection)
            activeFontFamily = item
          } else {
            activeFontSize = item
            dispatch("sizeChosen", selection)
          }
          showDropdown = false
        }}
        class="relative cursor-pointer select-none list-none rounded-md bg-transparent py-2 pl-5 pr-9 hover:bg-[#f7f7f7] dark:hover:bg-bodyblack dark:hover:text-slate-200"
      >
        <div class="flex items-center hover:bg-[#f7f7f7] dark:hover:bg-bodyblack">
          <div class="text-sm text-gray-800 dark:text-slate-200" style="font-family: {item};">{item}</div>
        </div>
      </li>
    {/each}
  </ul>
</div>
